import type { NotifyPort } from '@/features/messages/domain/notify'
import type { CreateTimeOffRequestInput, TimeOffPort, TimeOffRequest } from '../domain/timeoff'

const createTimeOffRequest = async (
	port: TimeOffPort,
	data: CreateTimeOffRequestInput & { memberName: string },
	notify: NotifyPort,
): Promise<TimeOffRequest> => {
	try {
		const request = await port.createRequest(data)
		notify.success('hr.timeOffSubmitted')
		return request
	} catch {
		notify.error('hr.timeOffSubmitFailed')
		throw new Error('Failed to submit time-off request.')
	}
}

export { createTimeOffRequest }
